import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-share-email',
  templateUrl: './share-email.component.html',
  styleUrls: ['./share-email.component.less']
})
export class ShareEmailComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/popups/share-map/share-email/share-email.component.ts